import gql from 'graphql-tag';

export const TEAMS_RESILIENCE_PULSE_CHECK = gql`
  query reportingTeamsResiliencePulseCheck {
    reportingTeamsResiliencePulseCheck
  }
`;
